import Link from '@mui/material/Link';
import { LinkProps as MuiLinkProps } from '@mui/material/Link';
import { Link as RouterLink, LinkProps as RouterLinkProps, To } from 'react-router-dom';
import { memo, forwardRef, ReactNode } from 'react';

type SelectMuiLinkProps = Omit<MuiLinkProps, 'href' | 'component'>;
type SelectRouterLinkProps = Omit<RouterLinkProps, 'to' | 'component'>;

export type MuiRouterLinkProps = SelectMuiLinkProps &
  SelectRouterLinkProps & {
    to?: To; // defines the href attr as well
    children?: ReactNode;
  };

export const MuiRouterLink = memo(
  forwardRef<HTMLAnchorElement, MuiRouterLinkProps>(({ to, children, ...rest }, ref) => {
    // If no `to` object passed just render
    // as a normal mui without polymorping.
    // This way handlers, props, etc wont be lost
    // and react-router-dom will not complain
    // about the missing or undefined 'to' prop
    if (!to) {
      return (
        <Link
          data-testid="generic-mui-link"
          ref={ref}
          {...rest}
        >
          {children}
        </Link>
      );
    }

    // else render as a polymorpthic router link
    return (
      <Link
        data-testid="generic-mui-router-link"
        component={RouterLink}
        to={to}
        ref={ref}
        {...rest}
      >
        {children}
      </Link>
    );
  }),
);

MuiRouterLink.displayName = 'MuiRouterLink';
